module.exports = __webpack_public_path__ + "img/MILID-logo-minimal.f7c76445.svg";